<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Warehouses</h4>
        </div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button @click="showAddForm = true; form = {warehouses_code: '', name: '', address_1: '', address_2: '', area_id: null}" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
          <vs-button
            @click="viewData"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeData"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="showFilterForm = true"
            icon="filter_list"
          >Filter</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
              <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
              <input type="file" ref="file" style="display: none" v-on:change="uploadExcel" />
              <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="data"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>
          Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total
          entries
        </b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

      <!-- Form filter data -->
      <vs-prompt buttons-hidden title="Filter" :active.sync="showFilterForm">
        <div class="con-exemple-prompt">
          <vs-input
            v-model="filter.warehouses_code"
            id="pan"
            class="mb-2 w-full"
            label="Warehouse Code"
          />
          <vs-input v-model="filter.name" class="mb-2 w-full" label="Name" />
          <vs-input v-model="filter.address_1" class="mb-2 w-full" label="Address 1" />
          <vs-input v-model="filter.address_2" class="mb-2 w-full" label="Address 2" />
          <label class="vs-input--label">Area</label>
          <vs-select
              class="selectExample"
              v-model="filter.area_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, area)"
          >
              <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" @click="filterData">Search</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form view data -->
      <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
        <div class="con-exemple-prompt">
          <vs-input
            v-model="form.warehouses_code"
            id="pan"
            class="mb-2 w-full wr_input"
            label="Warehouse Code"
            :disabled="!editMode"
          />
          <vs-input v-model="form.name" class="mb-2 w-full" label="Name" :disabled="!editMode" />
          <vs-input
            v-model="form.address_1"
            class="mb-2 w-full"
            label="Address 1"
            :disabled="!editMode"
          />
          <vs-input
            v-model="form.address_2"
            class="mb-2 w-full"
            label="Address 2"
            :disabled="!editMode"
          />
          <label class="vs-input--label">Area</label>
          <vs-select
              class="selectExample"
              v-model="form.area_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, area)"
              :disabled="!editMode"
          >
              <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mr-2" @click="editMode = true">Edit</vs-button>
            <vs-button color="primary" @click="saveData" :disabled="!editMode">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form add data -->
      <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="form.warehouses_code" class="mb-2 w-full" label="Warehouse Code"/>
          <vs-input v-model="form.name" class="mb-2 w-full" label="Name" />
          <vs-input v-model="form.address_1" class="mb-2 w-full" label="Address 1" />
          <vs-input v-model="form.address_2" class="mb-2 w-full" label="Address 2" />
          <label class="vs-input--label">Area</label>
          <vs-select
              class="selectExample"
              v-model="form.area_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, area)"
          >
              <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" @click="addData">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      data: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      selectedId: null,
      isLoading: false,
      editMode: false,
      filter: {
        warehouses_code: "",
        name: "",
        address_1: "",
        address_2: "",
        area_id: null
      },
      form: {
        warehouses_code: "",
        name: "",
        address_1: "",
        address_2: "",
        area_id: null,
      },
      area: {
        data: [],
        loading: false,
        endpoint: 'master/areas',
        objectKey: 'village'
      },

      // Show forms
      showFilterForm: false,
      showViewForm: false,
      showAddForm: false,

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0,

      // Popups
      areas: {
        endpoint: 'master/areas',
        show: false,
        gridOptions: {},
        columnDefs: [
          {
            headerName: "Village",
            field: "village",
          },
          {
            headerName: "Sub District",
            field: "subdistrict",
          },
          {
            headerName: "Village",
            field: "village",
          },
          {
            headerName: "District",
            field: "district",
          },
          {
            headerName: "Province",
            field: "province",
          },
          {
            headerName: "Post Code",
            field: "postcode",
          },
        ],
        rowData: [],
        filter: ''
      },
      areasFilter: {
        endpoint: 'master/areas',
        show: false,
        gridOptions: {},
        columnDefs: [
          {
            headerName: "Village",
            field: "village",
          },
          {
            headerName: "Sub District",
            field: "subdistrict",
          },
          {
            headerName: "Village",
            field: "village",
          },
          {
            headerName: "District",
            field: "district",
          },
          {
            headerName: "Province",
            field: "province",
          },
          {
            headerName: "Post Code",
            field: "postcode",
          },
        ],
        rowData: [],
        filter: ''
      },
    }
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    saveData() {
      this.isLoading = true;
      this.$http
        .put("master/warehouses/" + this.selectedId + "/update", this.form)
        .then(res => {
          this.isLoading = false;
          this.form = {
            warehouses_code: "",
            name: "",
            address_1: "",
            address_2: "",
            area_id: null,
          };
          this.editMode = false;
          this.showViewForm = false;
          this.selectedId = null;
          this.fetchData();
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          });
        })
        .catch(error => this.handleError(error));

    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("master/warehouses/store", this.form)
        .then(res => {
          this.isLoading = false;
          this.showAddForm = false;
          this.fetchData();
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          });
        })
        .catch(error => this.handleError(error));
    },
    removeData() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this data?",
        accept: () => {
          this.isLoading = true;
          this.$http
            .delete("master/warehouses/" + this.selectedId + "/destroy")
            .then(res => {
              this.$vs.notify({
                color: "success",
                title: "Data deleted",
                iconPack: "feather",
                icon: "icon-check",
                text: "The selected data was successfully deleted"
              });
              this.selectedId = null;
              this.fetchData();
            })
            .catch(error => this.handleError(error));
        }
      });
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    fetchData() {
      this.isLoading = true;
      Promise.all([
        this.$http.post(
          "master/warehouses?page=" + this.currentPage,
          this.filter
        )
      ])
        .then(
          this.$http.spread((warehouses) => {
            this.data = warehouses.data.data;
            this.totalPage = warehouses.data.last_page;
            this.currentPage = this.currentPage;
            this.dataTotal = warehouses.data.total;
            this.dataFrom = warehouses.data.from;
            this.dataTo = warehouses.data.to;
            this.isLoading = false;
          })
        )
        .catch(() => {
          this.isLoading = false;
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Server Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
          return;
        });
    },
    viewData() {
      this.form = {
        warehouses_code: "",
        name: "",
        address_1: "",
        address_2: "",
        area_id: '',
      }

      this.isLoading = true;
      this.$http
        .get("master/warehouses/" + this.selectedId)
        .then(res => {
          if(this.area.data.findIndex(a => a.id == res.data.area_id) === -1) {
            this.area.data.push({
              id: res.data.area_id,
              village: res.data.village
            })
          }

          this.editMode = false
          this.form = res.data;
          this.showViewForm = true;
        })
        .catch(error => this.handleError(error))
        .then(() => (this.isLoading = false));
    },
    filterData() {
      this.currentPage = 1;
      this.showFilterForm = false;
      this.fetchData();
    },
    getTemplate() {
      this.isLoading = true;
      this.$http
        .get("master/warehouses/report/gettemplate", {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "warehouse-upload-template.xlsx");
        });
    },
    uploadExcel(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      this.isLoading = true;
      this.$http
        .post("/master/warehouses/report/importexcel", form, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(resp => {
          this.isLoading = false;
          this.fetchData();
          this.$vs.notify({
            color: "success",
            title: "Upload Success",
            text: "Upload Data Warehouse Successfully"
          });
        })
        .catch(error => {
          this.isLoading = false;
          const message = error.response.data.message
            ? error.response.data.message
            : "Something went wrong";
          this.$vs.notify({
            color: "danger",
            title: "Upload Failed",
            text: message
          });
        });
    },
    exportExcel() {
      this.isLoading = true;
      this.$http
        .post("master/warehouses/report/exportexcel", this.filter, {
          responseType: "blob"
        })
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          this.isLoading = false;
          saveAs(blob, "warehouse-list-export.xlsx");
        });
    },
    showPopup(data) {
      if(data.rowData.length < 1) {
        this.searchPopup(data)
      }
      else {
        data.show = true
      }
    },
    searchPopup(data) {
      this.isLoading = true
      this.$http.post(data.endpoint, {dropdown_filter: data.filter})
      .then(res => {
        data.show = true
        this.areas.rowData = res.data.data
        this.areasFilter.rowData = res.data.data
        this.isLoading = false
      })
    },
    setData(data, model, modelField, fieldName) {
      let selectedRows = data.gridOptions.api.getSelectedRows()
      let selectedRowsString = null
      selectedRows.forEach(function(selectedRow, index) {
          if (index !== 0) {
              selectedRowsString += ", "
          }
          selectedRowsString = selectedRow
      });
      this.$set(model, modelField, selectedRowsString[fieldName])
      data.show = false
    },
    fetchDropdown() {
      this.isLoading = true
      return Promise.all([
          this.$http.post("master/areas"),
      ]).then(this.$http.spread((areas) => {
          areas.data.data.map(area => {
              if(this.area.data.findIndex(a => a.value == area.id) === -1) {
                  this.area.data.push(area)
              }
          })
      }))
    }
  },
  mounted() {
    this.fetchDropdown().then(() => this.fetchData())
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Warehouse Code",
        field: "warehouses_code",
        width: 120,
      },
      {
        headerName: "Name",
        field: "name",
        width: 120,
      },
      {
        headerName: "Address 1",
        field: "address_1",
        width: 120
      },
      {
        headerName: "Address 2",
        field: "address_2",
        width: 120
      },
      {
        headerName: "Area",
        field: "village",
        width: 120
      }
    ];
    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
};
</script>

<style lang="css">
.wr_input {
  border-radius: 12px;
}
</style>
